import { DotLottiePlayer } from '@dotlottie/react-player';
import { Typography } from 'antd';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Sheet } from 'react-modal-sheet';

import { AppContext } from '../../../../App';
import { getLottiePath } from '../../../../Utils/assetUtils';
import { ReactComponent as NoTxn } from '../../../../Assets/noTxn.svg';
import {
  getMonthFilterTransactions,
  getTransactions,
} from '../../../../Services/PFMClient/DashboardService';
import {
  convertToMonthYear,
  groupByTransactionsCredit,
  mergeObjects,
} from '../../../../Utils/utils';
import useINF from '../../../Dashboard/Common/InfiniteScroll';
import Transaction from '../../Common/Transaction';
import styles from './index.module.css';

const CategoryTransactions: React.FC<{
  selectedAccounts: any;
  isFilterOptions?: boolean;
  transactionIdList?: string[];
}> = ({
  selectedAccounts,
  isFilterOptions = false,
  transactionIdList = [],
}) => {
  const [selectedAccountsFilter, setSelectedAccountFilter] = useState<any>();

  useEffect(() => {
    setSelectedAccountFilter(selectedAccounts);
  }, [selectedAccounts]);

  const [allTransactions, setAllTransactions] = useState<any>({});
  const [selectedMonth, setSelectedMonth] = useState<any>();
  const [months, setMonths] = useState<any[]>([]);
  const [selectTxnType, setSelectedTxnType] = useState<any>();
  const [loading, setLoading] = useState(true);
  const { analyticsStatus }: any = useContext(AppContext);
  const [apiCallComplted, setApiCallCompleted] = useState(false);
  const [isViewAllTransactions, setIsViewAllTransactions] = useState(false);
  const [page, setPage] = useState(0);
  const [scrolled, setScrolled] = useState(false);
  const sheetRef: any = useRef({});

  useEffect(() => {
    if (sheetRef.current) {
      sheetRef.current.onscroll = function () {
        if (sheetRef.current.scrollTop > 18) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    }
  }, [isViewAllTransactions]);

  const pageSize = useMemo(() => {
    return 20;
  }, []);

  const [hasMore, setHasMore] = useState(true);
  const observer = useRef<any>();

  const { newObserver, ref } = useINF(observer, hasMore, setPage);
  observer.current = newObserver.current;

  const ref1 = useMemo(() => {
    return ref;
  }, []);

  useEffect(() => {
    if (apiCallComplted) {
      setLoading(false);
    }
  }, [allTransactions]);

  const getTransactionApiCall = () => {
    setApiCallCompleted(false);
    setLoading(true);
    getTransactions(
      {
        accountIdList: selectedAccounts,
        txnRefIdList: transactionIdList,
      },
      { page, pageSize }
    )
      .then((res) => res.data)
      .then((res) => {
        if (res.totalPages <= page + 1) {
          setHasMore(false);
        }
        setAllTransactions(
          mergeObjects(allTransactions, groupByTransactionsCredit(res.elements))
        );
      })
      .catch(() => {})
      .finally(() => {
        setApiCallCompleted(true);
      });
  };

  const getMonth = () => {
    getMonthFilterTransactions(selectedAccountsFilter.id)
      .then((res) => {
        setMonths(
          res.data.map((y: string) => {
            const monthYear = convertToMonthYear(y);
            return { value: y, label: monthYear };
          })
        );
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (selectedAccountsFilter && selectedAccountsFilter.id) getMonth();
  }, [selectedAccountsFilter]);

  useEffect(() => {
    if (analyticsStatus === 'PENDING') {
      setLoading(false);
    } else if (
      selectedAccountsFilter &&
      selectedAccountsFilter.id !== '' &&
      hasMore
    ) {
      getTransactionApiCall();
    }
  }, [selectTxnType, selectedMonth, selectedAccountsFilter, page, hasMore]);

  const showItems = () => {
    return Object.keys(allTransactions).length > 0 ? (
      <>
        {Object.keys(allTransactions).map((txn: any, i: number) => {
          const txnArray = allTransactions[txn];

          return (
            <>
              <Typography.Text className={styles.txnDateHeader}>
                {txn.toUpperCase()}
              </Typography.Text>

              <div className={styles.txnGroup}>
                {txnArray.map((transaction: any) => {
                  return (
                    <Transaction
                      className={styles.txnCard}
                      transaction={transaction}
                    />
                  );
                })}
              </div>
            </>
          );
        })}

        {loading ? (
          <DotLottiePlayer
            speed={2}
            id='loadingLottie'
            src={getLottiePath('loading.lottie')}
            autoplay
            loop
            style={{
              height: '80px',
            }}
          />
        ) : (
          <></>
        )}
      </>
    ) : loading ? (
      <DotLottiePlayer
        speed={2}
        id='loadingLottie'
        src={getLottiePath('loading.lottie')}
        autoplay
        loop
        style={{
          height: '130px',
        }}
      />
    ) : (
      <div className={styles.emptyContainer}>
        <NoTxn />
        <span className={styles.emptyText}>No transaction found</span>
      </div>
    );
  };

  return (
    <div
      className={`${styles.transactionContainer} transactionContainer ${
        isFilterOptions ? styles.padding16 : ''
      }`}
    >
      {isViewAllTransactions ? (
        <Sheet
          isOpen={isViewAllTransactions}
          onClose={() => {}}
          detent='full-height'
          draggable={false}
          className='allTransactionsSheet '
        >
          <Sheet.Container
            className={styles.sheet_container_categoryTransactions}
          >
            <div className={`${styles.allTxn}`} ref={sheetRef}>
              <CategoryTransactions
                selectedAccounts={selectedAccountsFilter}
                isFilterOptions={true}
              />
            </div>
          </Sheet.Container>
        </Sheet>
      ) : (
        <>
          <div className={styles.transactionSection}>
            {showItems()}
            {!loading ? <div className={styles.scrollSentinel} ref={ref1} /> : <></>}
          </div>
        </>
      )}
    </div>
  );
};

export default CategoryTransactions;
